import { HelpCircle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// A small "?" icon that reveals a one-line explanation — tap or hover.
export function FieldHint({ text, testid = "field-hint", side = "top" }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} aria-label="What's this?"
          className="ml-1 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full align-middle text-muted-foreground transition-colors hover:text-primary">
          <HelpCircle size={14} />
        </button>
      </PopoverTrigger>
      <PopoverContent side={side} align="start" className="max-w-[16rem] text-xs leading-relaxed" data-testid={`${testid}-content`}>
        {text}
      </PopoverContent>
    </Popover>
  );
}
